import styled from 'styled-components'

// T2-6045: Job Details page redesign — page is now a stack of rounded cards
// (header card with role title + "We're Hiring" pill + tooth illustration,
// then a Job Details card with icon chips, then a Job Description card).

// T2-6045: Wrapper height is driven by its content (NO min-height / no
// height: 100%). Otherwise the soft-grey backdrop stretches all the way to
// the bottom of the page below the Apply button. Rounded bottom corners +
// margin-bottom give the panel a clean trailing edge instead of bleeding
// into the surrounding white page area.
export const ContentContainer = styled.div`
  padding: 1rem 1rem 1.5rem;
  width: 100%;
  max-width: 720px;
  margin: 0 auto 1.5rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  background: #F8F9FB;
  border-radius: 0 0 16px 16px;
`

export const Card = styled.div`
  background: #fff;
  border: 1px solid #E5E7EB;
  border-radius: 12px;
  padding: 1.25rem;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04);

  @media (max-width: 480px) {
    padding: 1rem;
  }
`

export const HeaderCardInner = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 1rem;
  align-items: center;
`

export const HeaderTextStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  min-width: 0;
`

export const HeaderIllustrationWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: rgba(11, 69, 152, 0.08);
  color: var(--primary-blue, #0B4598);
  flex-shrink: 0;

  svg {
    width: 48px;
    height: 48px;
  }

  @media (max-width: 480px) {
    width: 64px;
    height: 64px;

    svg {
      width: 40px;
      height: 40px;
    }
  }
`

export const HiringPill = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  background: rgba(11, 69, 152, 0.08);
  color: var(--primary-blue, #0B4598);
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  width: fit-content;

  svg {
    width: 14px;
    height: 14px;
  }
`

export const HeaderRole = styled.h1`
  margin: 0;
  font-size: 1.5rem;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.87);
  line-height: 1.2;

  @media (max-width: 480px) {
    font-size: 1.25rem;
  }
`

export const HeaderPracticeRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  font-size: 0.95rem;
  color: rgba(0, 0, 0, 0.7);
`

export const HeaderMetaRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-top: 0.25rem;
  font-size: 0.85rem;
  color: rgba(0, 0, 0, 0.6);

  span {
    display: inline-flex;
    align-items: center;
    gap: 4px;
  }

  svg {
    width: 16px;
    height: 16px;
    color: var(--primary-blue, #0B4598);
  }
`

export const CardHeading = styled.h2`
  margin: 0 0 1rem;
  font-size: 1rem;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.87);
`

export const InfoChipsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1rem 1.25rem;

  @media (max-width: 600px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 380px) {
    grid-template-columns: 1fr;
  }
`

export const InfoChip = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.625rem;
  min-width: 0;
`

export const InfoChipIconWrap = styled.div`
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: rgba(11, 69, 152, 0.08);
  color: var(--primary-blue, #0B4598);

  svg {
    width: 18px;
    height: 18px;
  }
`

export const InfoChipText = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`

export const InfoChipLabel = styled.div`
  font-size: 0.7rem;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.55);
  text-transform: uppercase;
  letter-spacing: 0.4px;
`

export const InfoChipValue = styled.div`
  font-size: 0.9rem;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
  line-height: 1.3;
  word-break: break-word;
`

export const DescriptionText = styled.p`
  margin: 0;
  white-space: pre-line;
  font-size: 0.95rem;
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.75);
`

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  padding: 0;
  margin-top: 0.25rem;
  width: 100%;
  box-sizing: border-box;

  & > button {
    align-self: center;
  }
`

export const CoverLetterRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: #fff;
  border: 1px solid #E5E7EB;
  border-radius: 12px;
  padding: 0.75rem 1rem;
`

// Legacy popup styles (kept for callers using HygienistJobDetails styles file
// for popup helpers — no functional change).
export const PopupContainer = styled.div`
  padding: 1.5rem 1rem;
  border-radius: 8px;
  background: white;
`

export const PopupTitle = styled.div`
  margin-bottom: 1.75rem;
  font-size: 1.2rem;
  line-height: 1.4;
  font-weight: 600;
`

export const PopupDescription = styled.div`
  margin-bottom: 1.75rem;
  font-size: 1rem;
  line-height: 1.5;
`

export const PopupButtonsContainer = styled.div`
  margin-bottom: 1rem;
`
